module.exports = __webpack_public_path__ + "img/banner2.78f42ed6.png";